import 'css-chunksrc/client/scenes/listRemoval/listsList/list/styles.scss';export default {
  "headingWrapper": "_headingWrapper_louji_1",
  "contextualMenu": "_contextualMenu_louji_12",
  "name": "_name_louji_16",
  "displayedContextualMenu": "_displayedContextualMenu_louji_35",
  "iconBox": "_iconBox_louji_39",
  "icon": "_icon_louji_39",
  "label": "_label_louji_55",
  "elementsNbr": "_elementsNbr_louji_59",
  "main": "_main_louji_66",
  "lists": "_lists_louji_70",
  "openedIcon": "_openedIcon_louji_77",
  "root": "_root_louji_81",
  "rootHeading": "_rootHeading_louji_85",
  "dropBox": "_dropBox_louji_89",
  "droppable": "_droppable_louji_95",
  "droppableList": "_droppableList_louji_98",
  "droppableTask": "_droppableTask_louji_106",
  "droppableMilestone": "_droppableMilestone_louji_109",
  "element": "_element_louji_59",
  "dragged": "_dragged_louji_117",
  "elementLoaderWrapper": "_elementLoaderWrapper_louji_122",
  "elementLoader": "_elementLoader_louji_122",
  "empty": "_empty_louji_132",
  "elementCreationForm": "_elementCreationForm_louji_136"
};